import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumbs = ({ items = [] }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb navigation">
      <div className="container">
        <ol className="breadcrumb-list">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            const isCurrent = item.current || isLast;
            
            return (
              <li 
                key={index} 
                className={`breadcrumb-item ${isCurrent ? 'current' : ''}`}
              >
                {isCurrent ? (
                  <span 
                    className="breadcrumb-text"
                    aria-current="page"
                  >
                    {item.title}
                  </span>
                ) : (
                  <Link 
                    to={item.url} 
                    className="breadcrumb-link"
                  >
                    {item.title}
                  </Link>
                )}
                
                {!isLast && (
                  <i className="breadcrumb-separator fas fa-chevron-right" aria-hidden="true" />
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumbs;